import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-host-institution',
  templateUrl: './host-institution.component.html',
  styleUrls: ['./host-institution.component.css'],
})
export class HostInstitutionComponent implements OnInit {
  managementForm: FormGroup;
  selectedOption: string;
  inputValue: string;
  showInputField: string = 'No';
  private saveApi = environment.url + 'preincubation/hostinstitute/save';
  private getApi = environment.url + 'preincubation/hostinstitute/get?userId=';
  selectedCountry: string;
  /**
   * Constructor
   * @param fb Form builder
   * @param makeapi API service
   * @param getdata Value service
   * @param notify Notify service
   * @param dialog MatDialog
   * @param changeDetectorRef Change detector ref
   * @param media Media matcher
   */
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    /**
     * Form group
     */
    this.managementForm = this.fb.group({
      id: [0],
      hostInsId: [0],
      applicationId: [0],
      /**
       * Name field
       */
      name: ['', Validators.required],
      /**
       * Total departments field
       * @pattern ^((\\+91-?)|0)?[0-9]{0,5}$
       */
      totaldepartments: [
        '',
        [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{0,5}$')],
      ],
      /**
       * Type field
       */
      type: ['', Validators.required],
      /**
       * Other type field
       */
      othertype: [''],
      /**
       * Location field
       */
      location: ['', Validators.required],
      /**
       * Address field
       */
      address: ['', Validators.required],
      /**
       * District field
       */
      district: ['', Validators.required],
      /**
       * Pincode field
       * @pattern ^((\\+91-?)|0)?[0-9]{6,6}$
       */
      pincode: [
        '',
        [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{6,6}$')],
      ],
      /**
       * Website field
       * @pattern ^((https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?)$
       */
      website: ['', [Validators.required, this.urlValidator()]],
      /**
       * Email field
       */
      email: ['', [Validators.required, Validators.email]],
      /**
       * Phone field
       * @pattern ^((\\+91-?)|0)?[0-9]{10,10}$
       */
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      /**
       * Section field
       */
      section: [''],
      /**
       * CIN or Reference field
       */
      cinorref: [''],
      /**
       * Registration certificate file
       */
      regcertificatefile: [''],
      /**
       * Registration certificate filename
       */
      regcertificatefilename: [''],
    });
    /**
     * Set the mobile query
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    /**
     * Set the mobile query listener
     */
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  /**
   * Validator function for the URL input field.
   * @returns {ValidatorFn} A function that takes a control as an argument and
   * returns an object with a key-value pair of `website: true` if the input is invalid.
   */
  urlValidator() {
    return (control) => {
      const urlPattern =
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
      if (control.value && !urlPattern.test(control.value)) {
        return { website: true };
      }
      return null;
    };
  }
  districtdataList: string[] = [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanniyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Mayiladuthurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivagangai',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupathur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar',
  ];
  get setting() {
    return this.managementForm.controls;
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  roleName: any = '';
  /**
   * OnInit lifecycle hook
   * Initializes the component by fetching the host institution data and setting the role name.
   */
  ngOnInit(): void {
    // Fetch the host institution data
    this.getDataApi();
    // Set the role name
    this.roleName = sessionStorage.getItem('role');
    // Check if the user is allowed to edit the page based on the 'show' value
    if (this.show == 'true') {
      // If the user is not allowed to edit, reload the page
      window.location.reload();
    }
  }
  getValue: any = {};
  disableBtn: boolean;
  showForm: boolean = true;
  show;
  /**
   * Fetches the host institution data from the API and updates the component based on the response.
   * Also sets the 'showForm' flag to true or false based on the 'edit' value.
   * If the response status is not 'Failed', the form values are updated with the API response.
   */
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        // Set the 'show' value in session storage
        sessionStorage.setItem('show', data.show);
        this.show = sessionStorage.getItem('show');
        // Set the 'applicationId' value in session storage
        sessionStorage.setItem('applicationId', data.applicationId);
        // Update the component with the API response
        this.getValue = data;
        this.disableBtn = data.edit;
        // Set the 'showForm' flag based on the 'edit' value
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        // Update the form values if the response status is not 'Failed'
        if (data.responseStatus != 'Failed') {
          this.managementForm.patchValue(data);
          // Set the file upload values if the API response contains file data
          if (this.getValue.regcertificatefile) {
            this.FileValue = this.getValue.regcertificatefile;
            this.FileName = this.getValue.regcertificatefilename;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
          // Set the selected option if the API response contains a value for 'type'
          if (this.getValue.type) {
            this.selectedOption = this.getValue.type;
          }
        }
      });
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 10;
  logoCheck = false;
  fileErrorShow = false;
  /**
   * Handles the file upload event, checks file size and type, and updates the component state.
   * @param event - The file input change event
   */
  fileUpload(event) {
    // Select the first file from the event target
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      // Calculate the file size in megabytes
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      // Check if the file size exceeds the maximum limit
      if (fileSizeMB > this.maxSizeMB) {
        this.logoCheck = true;
        this.fileErrorShow = true;
        return;
      } else {
        this.logoCheck = false;
        this.fileErrorShow = false;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      // Check if the file type is PDF
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          // Update the URL and file value after reading the file
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;

          // Indicate successful upload and reset file error state
          this.disName = '✔ Uploaded';
          this.fileError = false;
        };
      } else {
        // Notify user of unsupported file format
        this.notify.notifyError('Only *pdf formats are allowed');
      }
    }
  }

  fileError = false;
  userId = sessionStorage.getItem('userId');
  applicationIds;
  showval;
  /**
   * Saves the host institution form data to the API.
   * If the form is invalid, notify the user and mark all fields as touched.
   * If the form is valid, save the form data to the API and notify the user of the result.
   */
  saveBtn() {
    let getform = this.managementForm.value;
    if (this.managementForm.invalid) {
      // If the form is invalid, notify the user and mark all fields as touched
      if (this.FileValue == '') {
        this.fileError = true;
      } else {
        this.fileError = false;
      }
      this.managementForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // If the form is valid, save the form data to the API
      if (this.FileValue != '') {
        this.fileError = false;
        getform.regcertificatefile = this.FileValue;
        getform.regcertificatefilename = this.FileName;
        getform.userid = this.userId;
        this.getdata.amizhthLoader('show');
        this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          this.fileErrorShow = false;
          if (data.responseStatus == 'Success') {
            // If the response is successful, update the application ID in session storage and notify the user
            this.applicationIds = sessionStorage.getItem('applicationId');
            if (this.applicationIds == '0') {
              window.location.reload();
            }
            sessionStorage.setItem('applicationId', data.applicationId);
            this.notify.notifysuccess(data.responseMessage);
            window.location.reload();
            this.getDataApi();
          } else {
            // If the response is not successful, notify the user of the error
            this.notify.notifyError(data.responseMessage);
          }
        });
      } else {
        this.fileError = true;
      }
    }
  }
  /**
   * Sets the validators for the 'othertype' control based on the selected option.
   *
   * If the selected option is 'other', the control is required.
   * If the selected option is not 'other', the control is not required.
   * @param option The selected option.
   */
  onSelect(option: string): void {
    this.selectedOption = option;
    if (option == 'other') {
      // If the selected option is 'other', the control is required.
      this.managementForm.controls['othertype'].setValidators([
        Validators.required,
      ]);
    } else {
      // If the selected option is not 'other', the control is not required.
      this.managementForm.controls['othertype'].setValue('');
      this.managementForm.controls['othertype'].clearValidators();
    }
    // Update the control's validity.
    this.managementForm.controls['othertype'].updateValueAndValidity();
  }
}
